var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support"},[_c('div',{staticClass:"support__content"},[_c('h1',[_vm._v("Support")]),_c('div',{staticClass:"support__text",domProps:{"innerHTML":_vm._s(this.dashboardDetailsInfo[0].SupportText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }